<fgb-page-header
  #walletHeader
  [pageTitle]="'rewards.nav.wallet'"
  [backButtonLink]="'/'"
  [showBalance]="false"
  [showQr]="false"
  [showFooter]="false"
></fgb-page-header>

<fgb-barcode [showBarcode]="true" [isWallet]="true"></fgb-barcode>

<!-- Wallet -->
<div #walletContainer class="wallet-container">
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="grab-point"><span class="minimize-icon"> </span></div>
  </ng-container>

  <fgb-banner [bannerTitle]="'rewards.nav.wallet' | translate"></fgb-banner>

  <div class="d-none d-lg-block">
    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  </div>

  <fgb-campaigns-v2-offers-list [showAllOffers]="false"></fgb-campaigns-v2-offers-list>

  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="container" [ngClass]="showCampaignOfferList ? 'mt-30' : 'mt-lg-0 mt-4'">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
    </div>
  </ng-container>

  <div class="container mt-4">
    <div class="history-container">
      <div class="history">
        <h5 class="title">{{ 'redemption.history.title' | translate }}</h5>
        <p class="description font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
      </div>
      <a class="font-size-14 claimed-text fw-bold text-center" [routerLink]="['/rewards/claimed']">
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
